import React from 'react';
import useTranslation from 'hooks/use-translation';

import DiscountBadge from 'shared/components/discount-badge/discount-badge';

export default function DiscountBadgeWrapper(props) {
  const { type, value, isMobile = false } = props;
  let specialsText = '';

  const { t } = useTranslation();

  if (isMobile) {
    specialsText =
      type === 'sale'
        ? t('common.discountApplirMobile', {
            // eslint-disable-next-line no-template-curly-in-string
            defaultValue: '{{amount}}% off',
            amount: value,
          })
        : t('common.discountAppliedMobile', {
            // eslint-disable-next-line no-template-curly-in-string
            defaultValue: '${{amount}} discount!',
            amount: value,
          });
  } else {
    specialsText =
      type === 'sale'
        ? t('common.discountApplirMobile', {
            // eslint-disable-next-line no-template-curly-in-string
            defaultValue: '{{amount}}% off',
            amount: value,
          })
        : t('common.discountApplied', {
            // eslint-disable-next-line no-template-curly-in-string
            defaultValue: '${{amount}} discount applied!',
            amount: value,
          });
  }

  return <DiscountBadge {...props} textDisplay={specialsText} />;
}
